module.exports = __webpack_public_path__ + "assets/img/269d-ch.svg";